import {lazy} from 'react';

import type {RouteConfig} from '../types';

import {Loadable} from '../components/Loadable';
import {questionnairesRoutesPath} from './path';

const QuestionnairePage = Loadable(
  lazy(
    () =>
      import(
        '@src/pages/Questionnaire' /* webpackChunkName: "questionnaire-page" */
      ),
  ),
);
const QuestionnaireTemplatesPage = Loadable(
  lazy(
    () =>
      import(
        '@src/pages/QuestionnaireTemplatesPage' /* webpackChunkName: "questionnaire-templates-page" */
      ),
  ),
);
const UserQuestionnairePage = Loadable(
  lazy(
    () =>
      import(
        '@src/pages/UserQuestionnaire' /* webpackChunkName: "user-questionnaire-page" */
      ),
  ),
);

export const questionnairesRoutes = [
  {
    element: <QuestionnairePage />,
    forCoach: true,
    path: questionnairesRoutesPath.questionnaire.$path() + '/*',
  },
  {
    element: <UserQuestionnairePage />,
    path: questionnairesRoutesPath.userQuestionnaire.$path() + '/*',
    publicElement: <UserQuestionnairePage />,
  },
  {
    element: <QuestionnaireTemplatesPage />,
    forCoach: true,
    path: questionnairesRoutesPath.questionnaire.template.create.$path(),
  },
] satisfies RouteConfig[];
